// The small Markdown subset the assistant may use: **bold** and bullet lists. No links, images or HTML ever render from
// model text; Bahi's own entity links come from ids on the proposal card.
import { Fragment, type ReactNode } from 'react';

function inline(text: string, key: number): ReactNode {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return <Fragment key={key}>{parts.map((p, i) => (p.startsWith('**') && p.endsWith('**') ? <b key={i}>{p.slice(2, -2)}</b> : <Fragment key={i}>{p}</Fragment>))}</Fragment>;
}

export function Md({ text }: { text: string }) {
  const lines = text.split('\n');
  const out: ReactNode[] = []; let list: ReactNode[] = [];
  const flush = () => { if (list.length) { out.push(<ul key={`l${out.length}`}>{list}</ul>); list = []; } };
  lines.forEach((line, i) => {
    const m = line.match(/^\s*(?:[-*•]|\d+[.)])\s+(.*)$/);
    if (m) { list.push(<li key={i}>{inline(m[1], i)}</li>); return; }
    flush();
    if (line.trim() === '') { out.push(<div key={i} style={{ height: 6 }} />); return; }
    out.push(<p key={i} style={{ margin: '2px 0' }}>{inline(line, i)}</p>);
  });
  flush();
  return <div className="ai-md">{out}</div>;
}
